import axios from "axios";
import { toast } from "react-toastify";


const CustomerService = {
  // @ts-ignore
  listCustomer: async (rowsPerPage, page, search) => {
    const token = localStorage.getItem("user-token");
    // @ts-ignore
    // eslint-disable-next-line no-unused-vars
    const pageUrl = page ? '&pageNumber='+page : '';
    // @ts-ignore
    // eslint-disable-next-line no-unused-vars
    const searchUrl = search ? '&'+search : '';

    const config = {
      method: "get",
      maxBodyLength: Infinity,
      // url: process.env.REACT_APP_DELEND_API+"/subscriptions/customers?pageSize="+rowsPerPage+pageUrl+searchUrl,
      url: process.env.REACT_APP_DELEND_API+"/subscriptions/customers?pageSize=10",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return axios(config)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        toast.error(error.response.data.errorDescription);
      });
  },
};

export default CustomerService;
